import React, { FC } from 'react';

import { DataAccessRolePage } from '@ariksa/inventory-core';
import { Flex, Stack } from '@chakra-ui/react';

import { PageInfo, Pagination } from 'components/Navigation';

import { RoleList } from './RoleList';

// A short list fits beside the other details.
export const ROLE_PAGE_SIZES = [10, 20, 50];

interface GrantingRolesProps {
  roles: DataAccessRolePage;
  // The identity itself grants something on the table.
  direct: boolean;
  pageInfo: PageInfo;

  onPageChange(info: PageInfo): void;
}

/**
 * Who grants anything on the table: "Direct" for the identity itself, then
 * one page of roles, by name. The list is the one the "via" popover shows, so
 * a role opens in the drawer here too.
 */
export const GrantingRoles: FC<GrantingRolesProps> = props => {
  const { roles, direct, pageInfo, onPageChange } = props;
  const items = roles.items ?? [];
  const total = roles.total ?? 0;
  return (
    <Stack spacing={1}>
      <RoleList roles={items} direct={direct} />
      {(total > pageInfo.page_size || pageInfo.page_number > 1) && (
        <Flex justify="flex-end">
          <Pagination
            totalCount={total}
            pageInfo={pageInfo}
            pageSizes={ROLE_PAGE_SIZES}
            onChange={onPageChange}
          />
        </Flex>
      )}
    </Stack>
  );
};
